"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _useComponentStyling3 = _interopRequireDefault(require("../../hooks/useComponentStyling"));

var _ = require("..");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var BASE_CLASS = "lth-c-tabs";

function Tab(_ref) {
  var children = _ref.children;
  return children || null;
}

Tab.METADATA = {
  name: "Tabs.Tab"
};

function Tabs(props) {
  var tabs = props.children,
      selected = props.selected,
      onChange = props.onChange;
  var selectedIndexFromProp = useSelectedIndex(selected, tabs);

  var _useState = (0, _react.useState)(selectedIndexFromProp),
      _useState2 = _slicedToArray(_useState, 2),
      selectedIndexFromState = _useState2[0],
      setSelectedIndex = _useState2[1];

  var selectedIndex = selected !== undefined ? selectedIndexFromProp : selectedIndexFromState;

  var _buildTabs = buildTabs(tabs, selectedIndex, selectTab),
      buttons = _buildTabs.buttons,
      tabsContent = _buildTabs.tabsContent;

  var _useComponentStyling = (0, _useComponentStyling3.default)(BASE_CLASS, props, ["density", "size", "type"]),
      style = _useComponentStyling.style,
      classNames = _useComponentStyling.classNames;

  return /*#__PURE__*/_react.default.createElement("div", {
    style: style,
    className: classNames
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(BASE_CLASS, "__buttons"),
    tabIndex: 0,
    onKeyDown: keyDown
  }, buttons), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(BASE_CLASS, "__content")
  }, tabsContent));

  function selectTab(event, index, id) {
    event.preventDefault();
    setSelectedIndex(index);

    if (onChange) {
      onChange(index, id);
    }
  }

  function keyDown(event) {
    var key = event.key;

    if (["ArrowLeft", "ArrowRight"].includes(key)) {
      var upcomingIndex = getUpcomingIndex(selectedIndex, tabs, key === "ArrowLeft");
      setSelectedIndex(upcomingIndex);
    }
  }
}

function getUpcomingIndex(currIndex, tabs, getPrev) {
  var start = getPrev ? 0 : currIndex + 1;
  var end = getPrev ? currIndex : tabs.length; // when selected index is at the edge of the group

  if (start === end) {
    return currIndex;
  }

  var upcomingTabs = tabs.slice(start, end);

  if (getPrev) {
    upcomingTabs.reverse();
  }

  var upcomingIndex = tabs.indexOf(upcomingTabs.find(function (tab) {
    return !tab.props.disabled;
  }));
  return upcomingIndex;
}

function useSelectedIndex(selected, tabs) {
  var tabsIds = tabs.map(function (tab) {
    return tab.props.id;
  });
  var selectedIndex = (0, _react.useMemo)(function () {
    var index = 0;

    if (typeof selected === "string") {
      index = tabsIds.indexOf(selected);
    } else if (typeof selected === "number") {
      index = selected;
    }

    return index;
  }, [selected, JSON.stringify(tabsIds)]);
  return selectedIndex;
}

function buildTabs(tabs, selectedIndex, buttonClicked) {
  var buttons = [];
  var tabsContent = [];
  tabs.forEach(function (tab, index) {
    var isSelected = selectedIndex === index;
    buttons.push( /*#__PURE__*/_react.default.createElement(TabButton, _extends({
      key: index
    }, tab.props, {
      tab: tab,
      index: index,
      selected: isSelected,
      selectedIndex: selectedIndex,
      buttonClicked: buttonClicked
    })));
    tabsContent.push( /*#__PURE__*/_react.default.createElement(TabContent, {
      tab: tab,
      index: index,
      selected: isSelected,
      key: index
    }));
  });
  return {
    buttons: buttons,
    tabsContent: tabsContent
  };
}

function TabButton(props) {
  var tab = props.tab,
      index = props.index,
      buttonClicked = props.buttonClicked,
      selected = props.selected;

  var _useComponentStyling2 = (0, _useComponentStyling3.default)("".concat(BASE_CLASS, "__button"), props, ["selected"]),
      classNames = _useComponentStyling2.classNames;

  var badge = tab.props.badge;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(BASE_CLASS, "__button-container"),
    key: index
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: classNames,
    index: index,
    tabIndex: -1,
    onClick: function onClick(e) {
      return buttonClicked(e, index, tab.props.id);
    },
    disabled: tab.props.disabled
  }, tab.props.label, badge ? /*#__PURE__*/_react.default.createElement(_.Badge, {
    label: badge,
    size: "small",
    variant: selected ? "primary" : "common",
    disabled: tab.props.disabled
  }) : null));
}

function TabContent(_ref2) {
  var tab = _ref2.tab,
      index = _ref2.index,
      selected = _ref2.selected;
  var dynamicStyle = {
    display: selected ? "block" : "none"
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(BASE_CLASS, "__content"),
    style: dynamicStyle,
    key: index
  }, tab.props.children);
}

Tabs.Tab = Tab;
Tabs.METADATA = {
  name: "Tabs",
  description: "Use to alternate among related views within the same context.",
  props: [{
    name: "type",
    type: "string",
    description: "choose between 2 types of tab width - fixed, or content-fit",
    category: "style",
    default: "content-fit",
    options: [{
      value: "content-fit",
      label: "content-fit"
    }, {
      value: "fixed",
      label: "fixed"
    }]
  }, {
    name: "density",
    type: "string",
    description: "choose between 2 types of tab height - regular, or compact",
    category: "style",
    default: "regular",
    options: [{
      value: "regular",
      label: "regular"
    }, {
      value: "compact",
      label: "compact"
    }]
  }, {
    name: "size",
    type: "string",
    description: "choose between two options of font size - medium or small",
    category: "style",
    default: "medium",
    options: [{
      value: "medium",
      label: "medium"
    }, {
      value: "small",
      label: "small"
    }]
  }, {
    name: "selected",
    type: "string",
    description: "Set selected tab",
    category: "value",
    options: [{
      value: undefined,
      label: "Not set"
    }, {
      value: 0,
      label: "Tab 1"
    }, {
      value: 1,
      label: "Tab 2"
    }, {
      value: 2,
      label: "Tab 3"
    }, {
      value: "tab1",
      label: "Tab 1 via id"
    }, {
      value: "tab2",
      label: "Tab 2 via id"
    }, {
      value: "tab3",
      label: "Tab 3 via id"
    }]
  }],
  content: {
    default: [/*#__PURE__*/_react.default.createElement(Tabs.Tab, {
      id: "tab1",
      label: "Tab 1 very very very long Label"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Tab 1 Content")), /*#__PURE__*/_react.default.createElement(Tabs.Tab, {
      id: "tab2",
      label: "2",
      disabled: true
    }, /*#__PURE__*/_react.default.createElement("p", null, "Tab 2 Content")), /*#__PURE__*/_react.default.createElement(Tabs.Tab, {
      id: "tab3",
      label: "medium 3",
      badge: "24"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Tab 3 Content"))]
  }
};
var _default = Tabs;
exports.default = _default;